'use strict';

/* eslint-disable sort-keys */
module.exports = Object.freeze({
        // same as DOM DOCUMENT_POSITION_
        DISCONNECTED: 1,
        PRECEDING: 2,
        FOLLOWING: 4,
        CONTAINS: 8,
        CONTAINED_BY: 16,
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/_symbol-tree@3.2.4@symbol-tree/lib/TreePosition.js
// module id = iIw8
// module chunks = 0